export default __webpack_public_path__ + "static/SRUS RTL4 - Especification Del Producto y Datos Técnicos-b69bfb66fd791367d5e4fdc765ee5b6e.pdf";